/* SACRA 2026 theme app: images, toast, reveal, carousel, menu, quick add, subscribe, breathe */
(function(){
  window.hydrateImgs=function(root){
    (root||document).querySelectorAll('img[data-img]').forEach(function(im){
      var k=im.getAttribute('data-img'); if(window.SACRA_IMG&&SACRA_IMG[k]){ im.src=SACRA_IMG[k]; im.removeAttribute('data-img'); }
    });
  };
  var tt; window.toast=function(msg){var t=document.getElementById('toast'); if(!t) return; t.textContent=msg;t.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){t.classList.remove('show')},2400)};
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(entries){
    entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}});
  },{rootMargin:'0px 0px -8% 0px',threshold:.08}):null;
  window.revealScan=function(){
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
      if(!io){el.classList.add('in');return}
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight*0.92){el.classList.add('in')}else{io.observe(el)}
    });
  };
  if(window.Shopify&&Shopify.designMode){ document.addEventListener('shopify:section:load',function(){setTimeout(revealScan,50); hydrateImgs();}); }
  /* mobile menu */
  var mm=document.getElementById('mobileMenu');
  function closeMenu(){ if(mm){mm.hidden=true; document.body.classList.remove('menu-open')} }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-menu]')){ mm.hidden=!mm.hidden; document.body.classList.toggle('menu-open',!mm.hidden); }
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeMenu()});
  /* carousel buttons */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-car]'); if(!b) return;
    var car=b.closest('section,.shopify-section').querySelector('.carousel'); if(!car) return;
    car.scrollBy({left:parseInt(b.dataset.car,10)*Math.min(440,car.clientWidth*0.8),behavior:'smooth'});
  });
  /* size pick on cards: updates the sibling quick-add button and price */
  function pickSize(el){
    var wrap=el.closest('[data-sizepick]'); if(!wrap) return;
    wrap.querySelectorAll('[data-size-pick]').forEach(function(x){ x.classList.toggle('on',x===el); x.setAttribute('aria-pressed',x===el?'true':'false'); });
    var scope=el.closest('.pk,.pcard,.scross,.cross-item,.vprod,[data-sizepick-scope]')||wrap.parentNode;
    scope.querySelectorAll('[data-quick-add]').forEach(function(b){ b.setAttribute('data-quick-add',el.getAttribute('data-size-pick')); });
    scope.querySelectorAll('[data-price-out]').forEach(function(o){ o.textContent=el.getAttribute('data-price'); });
  }
  document.addEventListener('click',function(e){
    var s=e.target.closest('[data-size-pick]'); if(!s) return;
    e.preventDefault(); e.stopPropagation(); if(s.classList.contains('off')) return; pickSize(s);
  },true);
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ') return; var s=e.target.closest('[data-size-pick]'); if(!s) return; e.preventDefault(); pickSize(s);
  });
  /* quick add: data-variant on the card button */
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-quick-add]'); if(!q) return;
    e.preventDefault(); e.stopPropagation();
    var id=q.getAttribute('data-quick-add'); if(!id) return;
    q.classList.add('is-loading');
    fetch((window.routes&&routes.cart_add_url)||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}],sections:'sacra26-cart-drawer'})})
    .then(function(r){return r.json()}).then(function(res){
      q.classList.remove('is-loading');
      if(res.status&&res.status>=400){ window.toast(res.description||res.message||'Could not add.'); return; }
      if(window.SacraDrawer){ SacraDrawer.afterAdd(res); } else { window.toast('Added to your bag'); }
    }).catch(function(){ q.classList.remove('is-loading'); window.toast('Could not add. Please try again.'); });
  });
  /* subscribe: Klaviyo client API if configured, else Shopify customer form */
  window.sacraSubscribe=function(email, source, props){
    var k=window.SACRA_KLAVIYO||{};
    if(k.company&&k.list){
      var attrs={email:email,properties:Object.assign({source:source||'site'},props||{})};
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(k.company),{method:'POST',
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:attrs}},custom_source:source||'site'},relationships:{list:{data:{type:'list',id:k.list}}}}})}).catch(function(){});
    }
    var fd=new FormData(); fd.append('form_type','customer'); fd.append('utf8','✓'); fd.append('contact[email]',email); fd.append('contact[tags]','newsletter,'+(source||'site'));
    return fetch('/contact',{method:'POST',body:fd}).catch(function(){});
  };
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.matches('form[data-nl]')) return; e.preventDefault();
    var i=f.querySelector('input[type=email]'); if(!i||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(i.value.trim())){if(i)i.focus();return}
    var v=i.value.trim(); i.value=''; window.sacraSubscribe(v,'newsletter',{}); toast(f.dataset.nl||'Welcome to the ritual');
  });
  /* ingredients glossary filter */
  document.addEventListener('click',function(e){
    var c=e.target.closest('[data-ing-filter]'); if(!c) return;
    var v=c.getAttribute('data-ing-filter');
    document.querySelectorAll('[data-ing-filter]').forEach(function(x){x.classList.toggle('on',x===c)});
    document.querySelectorAll('[data-ing-products]').forEach(function(it){ it.hidden = v!=='all' && (it.getAttribute('data-ing-products')||'').indexOf(v)<0; });
    document.querySelectorAll('[data-ing-group]').forEach(function(g){ g.hidden = !g.querySelector('[data-ing-products]:not([hidden])'); });
  });
  /* product size select -> price + variant id */
  document.addEventListener('change',function(e){
    var s=e.target.closest('select[data-size-select]'); if(!s) return;
    var o=s.options[s.selectedIndex]; var form=s.closest('form'); var idInput=form&&form.querySelector('input[name=id]'); if(idInput) idInput.value=o.value;
    var price=document.querySelector('[data-price-out]'); if(price&&o.dataset.price) price.textContent=o.dataset.price;
  });
  /* breathe */
  window.SacraBreath=(function(){
    var root=document.getElementById('breath'); if(!root) return {reset:function(){}};
    var word=document.getElementById('bword'), time=document.getElementById('btime'), btn=root.querySelector('[data-b-start]');
    var timer=null,left=60,phaseT=null;
    function setPhase(p){ root.classList.remove('in','out'); if(p) root.classList.add(p); word.textContent=p==='in'?'Breathe in':p==='out'?'Breathe out':'Ready'; }
    function stop(){ clearInterval(timer); clearTimeout(phaseT); timer=null; root.classList.remove('running'); }
    function reset(){ stop(); left=60; time.textContent='60'; setPhase(null); btn.innerHTML='Start <span class="arrow"></span>'; }
    function cycle(){ setPhase('in'); phaseT=setTimeout(function(){ setPhase('out'); phaseT=setTimeout(cycle,6000); },4000); }
    function start(){ if(timer){ reset(); return; } left=60; root.classList.add('running'); btn.textContent='Stop'; cycle();
      timer=setInterval(function(){ left--; time.textContent=String(left); if(left<=0){ stop(); setPhase(null); word.textContent='Now the serum.'; btn.innerHTML='Again <span class="arrow"></span>'; if(window.Shopify&&Shopify.analytics) try{Shopify.analytics.publish('breath_complete',{})}catch(e){} } },1000); }
    btn.addEventListener('click',start);
    return {reset:reset,stop:stop};
  })();
  function boot(){ hydrateImgs(); var qp=document.getElementById('quizPage'); if(qp&&window.SacraQuiz&&!qp.dataset.mounted){ qp.dataset.mounted='1'; SacraQuiz.mount(qp,{focus:false}); hydrateImgs(qp); } setTimeout(revealScan,40); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.addEventListener('load',function(){setTimeout(revealScan,100)});
})();
